import { render, staticRenderFns } from "./DepartamentoView.vue?vue&type=template&id=24454262"
import script from "./DepartamentoView.vue?vue&type=script&lang=js"
export * from "./DepartamentoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports